/**
 * LoginScreen — the only door into the app.
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS,
 * THIS BREAKS THE AUTH. The redirect must be derived from
 * `window.location.origin` at click time so preview and production each send
 * the user back to their own domain.
 */
import { BarChart3, ShieldCheck } from "lucide-react";

export function LoginScreen() {
  const signIn = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT
    // URLS, THIS BREAKS THE AUTH.
    const redirectUrl = window.location.origin + "/";
    window.location.href =
      `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div
      data-testid="login-screen"
      className="min-h-screen flex items-start sm:items-center justify-center bg-surface-subtle px-4
                 pt-12 pb-[calc(2rem+env(safe-area-inset-bottom))] sm:py-8"
    >
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-6 sm:mb-8">
          <div className="bg-brand/20 p-2.5 rounded-xl border border-brand/30">
            <BarChart3 className="w-6 h-6 text-brand-accent" />
          </div>
          <div>
            <h1 className="text-xl font-semibold text-content tracking-tight">
              ETF Holdings Consolidator
            </h1>
            <p className="text-xs text-content-muted">
              Le holdings dei tuoi ETF in un unico portafoglio
            </p>
          </div>
        </div>

        <div className="bg-surface border border-line rounded-card shadow-card p-6 space-y-5">
          <div>
            <h2 className="text-base md:text-lg text-content font-medium">
              Accedi al tuo spazio
            </h2>
            <p className="text-sm text-content-secondary mt-1.5 leading-relaxed">
              Scegli i tuoi ETF, imposta i pesi e ottieni le holdings consolidate.
              Salva i portafogli e ritrovali ad ogni accesso: le tue analisi sono
              visibili soltanto a te.
            </p>
          </div>

          <button
            data-testid="google-login-btn"
            onClick={signIn}
            className="w-full flex items-center justify-center gap-3 py-3 rounded-lg bg-white text-[#1f1f1f] border border-line text-sm font-medium hover:bg-surface-subtle transition-colors duration-base ease-system"
          >
            <svg className="w-4 h-4" viewBox="0 0 24 24" aria-hidden="true">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.76h3.57c2.08-1.92 3.27-4.74 3.27-8.09z" />
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.76c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A10.99 10.99 0 0 0 12 23z" />
              <path fill="#FBBC05" d="M5.84 14.11a6.6 6.6 0 0 1 0-4.22V7.05H2.18a10.99 10.99 0 0 0 0 9.9l3.66-2.84z" />
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.05l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z" />
            </svg>
            Continua con Google
          </button>

          <div className="flex items-start gap-2 pt-1">
            <ShieldCheck className="w-3.5 h-3.5 text-content-muted mt-0.5 flex-shrink-0" />
            <p className="text-xs text-content-muted leading-snug">
              Al primo accesso il tuo account resta in attesa di approvazione.
              Riceverai accesso completo appena viene abilitato.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginScreen;
